@if (users.length > 0) {
  <div class="active-users-container">
    @if (showLabel()) {
      <span class="active-users-label">{{ labelText() }}</span>
    }
    <div class="active-user-initials" (click)="op.toggle($event)">
      @for (user of displayedUsers; track user; let i = $index) {
        <div class="user-circle" [class]="getAppClass(user)" [style.z-index]="displayedUsers.length - i">
          {{ getInitials(user) }}
        </div>
      }
      @if (hasRemainingUsers) {
        <div class="user-circle remaining-count">+{{ remainingCount }}</div>
      }
    </div>
    <p-popover #op [showCloseIcon]="false" [dismissable]="true" styleClass="active-users-overlay">
      <div class="active-users-list">
        @for (user of users; track user) {
          <div class="user-item">
            <div class="user-avatar" [class]="getAppClass(user)">
              {{ getInitials(user) }}
            </div>
            <div class="user-details">
              <div class="user-name">{{ getFullName(user) }}</div>
              <div class="user-meta">
                <span class="user-timestamp">{{ getFormattedTimestamp(user) }}</span>
              </div>
              <div class="user-app">Opened in: {{ getApplicationLabel(user) }}</div>
            </div>
          </div>
        }
      </div>
    </p-popover>
  </div>
}
